import { defaultCurrencyFormatter, TableField } from "../../table-field";

const detalhes: TableField = {
    key: "show_details",
    label: "Detalhes",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
}
const nome: TableField = {
    key: "nome",
    label: "Nome",
    tdClass: ["quebrarPorPalavra", "text-center"],
    thClass: ["text-center"],
    sortable: true,
    formatter: (
        value: any,
        key: string, // nome da const
        item: any // response
    ): string => {
        return item?.IdCargoNavigation?.DeNomenclaturaCargo ||
            `Cargo temporário - ${item?.IdCargoProcessoSeletivoNavigation?.DsNomenclatura}` ||
            "";
    }
}
const remuneracao: TableField = {
    key: "remuneracao_inicial",
    label: "Remuneração Inicial",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
    formatter: defaultCurrencyFormatter,
}
const localidade: TableField = {
    key: "localidade",
    label: "Localidade",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
    formatter: (s: string): string => (s.trim().length > 0 ? s : '-')
}
const especialidade: TableField = {
    key: "especialidade",
    label: "Especialidade",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
    formatter: (s: string): string => (s.trim().length > 0 ? s : '-')
}

export const fieldsCargosClassificados: TableField[] = [
    detalhes,
    nome,
    remuneracao,
    localidade,
    especialidade,

];
